(function () {
  const dataLayer = (window.dataLayer = window.dataLayer || []);
  const siteId = document.documentElement.dataset.siteId || "pu.lavanda.cash";
  const pageLoadedAt = Date.now();
  const selected = {
    firstService: "",
    serviceChip: "",
    startedForms: new WeakSet(),
  };
  const metrikaCounters = {
    "pu.lavanda.cash": 110063259,
    "tm.lavanda.cash": 110063314,
    "fl.lavanda.cash": 110063290,
    "ag.lavanda.cash": 110063331,
  };

  function track(event, payload) {
    dataLayer.push({
      event,
      site_id: siteId,
      timestamp: new Date().toISOString(),
      ...(payload || {}),
    });
  }

  function reachApplicationSuccessGoal() {
    const counterId = metrikaCounters[siteId];
    if (!counterId || typeof window.ym !== "function") return;
    window.ym(counterId, "reachGoal", "application_success");
  }

  function qs(selector, root) {
    return (root || document).querySelector(selector);
  }

  function qsa(selector, root) {
    return Array.from((root || document).querySelectorAll(selector));
  }

  function getCookie(name) {
    const prefix = `${encodeURIComponent(name)}=`;
    const match = document.cookie
      .split(";")
      .map((part) => part.trim())
      .find((part) => part.startsWith(prefix));

    return match ? decodeURIComponent(match.slice(prefix.length)) : "";
  }

  function setCookie(name, value, options) {
    const settings = options || {};
    const parts = [`${encodeURIComponent(name)}=${encodeURIComponent(value)}`];

    if (settings.maxAge) parts.push(`Max-Age=${settings.maxAge}`);
    if (settings.path) parts.push(`Path=${settings.path}`);
    if (settings.sameSite) parts.push(`SameSite=${settings.sameSite}`);
    if (settings.secure) parts.push("Secure");

    document.cookie = parts.join("; ");
  }

  function getParam(name) {
    return new URLSearchParams(window.location.search).get(name) || "";
  }

  function fillHiddenFields(form) {
    const hiddenMap = {
      utm_source: getParam("utm_source"),
      utm_medium: getParam("utm_medium"),
      utm_campaign: getParam("utm_campaign"),
      utm_content: getParam("utm_content"),
      utm_term: getParam("utm_term"),
      form_loaded_at: String(pageLoadedAt),
      referrer: document.referrer,
      device_type: window.matchMedia("(max-width: 760px)").matches ? "mobile" : "desktop",
      browser_language: navigator.language || "",
      first_service_selected: selected.firstService,
      service_chip_clicked: selected.serviceChip,
    };

    Object.entries(hiddenMap).forEach(([name, value]) => {
      const input = qs(`[name="${name}"]`, form);
      if (input) input.value = value;
    });
  }

  function setService(service, options) {
    selected.serviceChip = service;
    if (!selected.firstService) selected.firstService = service;

    qsa('input[name="service"]').forEach((input) => {
      input.value = service;
      input.dispatchEvent(new Event("input", { bubbles: true }));
    });

    qsa(".chip").forEach((chip) => {
      chip.classList.toggle("is-selected", chip.dataset.service === service);
    });

    track("service_chip_click", { service });

    if (options && options.scroll) {
      qs("#request").scrollIntoView({ behavior: "smooth", block: "start" });
      setTimeout(() => {
        const target = qs('.lead-form--mini input[name="service"]');
        if (target) target.focus();
      }, 350);
    }
  }

  function getFormData(form) {
    const data = {};
    new FormData(form).forEach((value, key) => {
      if (data[key]) {
        data[key] = `${data[key]}, ${value}`;
      } else {
        data[key] = value;
      }
    });
    return data;
  }

  function estimateServices(data) {
    const extra = (data.additional_services || "")
      .split(/[,;\n]+/)
      .map((item) => item.trim())
      .filter(Boolean);
    return String(1 + extra.length);
  }

  function showError(form, message) {
    const error = qs(".form-error", form);
    if (error) error.textContent = message || "";
  }

  function isPhoneContact(value) {
    return /^[+]?\d[\d\s().-]{5,}$/.test(value);
  }

  function isTelegramUsername(value) {
    return /^(?=.{2,64}$)(?=.*[A-Za-zА-Яа-яЁё])[\w.]+$/.test(value);
  }

  function isTelegramLink(value) {
    return /^(?:https?:\/\/)?(?:www\.)?(?:t\.me|telegram\.me)\/(?=.{2,64}\/?$)(?=.*[A-Za-zА-Яа-яЁё])[\w.]+\/?$/i.test(value);
  }

  function validateContact(value) {
    const contact = String(value || "").trim();
    if (!contact) return false;
    if (isPhoneContact(contact)) return true;
    if (contact.startsWith("@")) return isTelegramUsername(contact.slice(1));
    if (isTelegramLink(contact)) return true;
    return isTelegramUsername(contact);
  }

  function validateBase(form) {
    const service = qs('input[name="service"]', form);
    const amount = qs('input[name="amount"]', form);
    const contact = qs('input[name="contact"]', form);

    if (!service || service.value.trim().length < 2) {
      showError(form, "Напишите сервис, который хотите оплатить — например ChatGPT, Claude, Midjourney или Cursor.");
      service && service.focus();
      return false;
    }

    if (service.value.trim().length > 200) {
      showError(form, "Название сервиса слишком длинное.");
      service.focus();
      return false;
    }

    if (amount && amount.value.trim().length > 200) {
      showError(form, "Описание тарифа или суммы слишком длинное.");
      amount.focus();
      return false;
    }

    if (!contact || !validateContact(contact.value)) {
      showError(form, "Укажите WhatsApp номер, Telegram @username или ссылку на Telegram аккаунт.");
      contact && contact.focus();
      return false;
    }

    showError(form, "");
    return true;
  }

  function validateStaticConsents(form) {
    const group = qs(".static-consents", form);
    if (!group) return true;

    const checkboxes = qsa('input[type="checkbox"]', group);
    if (checkboxes.every((checkbox) => checkbox.checked)) {
      showError(form, "");
      return true;
    }

    showError(form, "Поставьте обе галочки, чтобы мы могли обработать заявку.");
    const firstUnchecked = checkboxes.find((checkbox) => !checkbox.checked);
    firstUnchecked && firstUnchecked.focus();
    return false;
  }

  function getLeadData(form) {
    fillHiddenFields(form);
    return getFormData(form);
  }

  function persistLeadLocally(data) {
    const leads = JSON.parse(localStorage.getItem(`lavanda_leads_${siteId}`) || "[]");
    leads.push(data);
    localStorage.setItem(`lavanda_leads_${siteId}`, JSON.stringify(leads));

    track("form_submit", {
      form: "mini",
      service: data.service,
      urgency: data.urgency || "",
      regular: data.regular || "",
      services_estimated: estimateServices(data),
    });
  }

  function validateQuestion(form) {
    const contact = qs('input[name="contact"]', form);
    const question = qs('textarea[name="question"]', form);

    if (!contact || !validateContact(contact.value)) {
      showError(form, "Укажите WhatsApp номер, Telegram @username или ссылку на Telegram аккаунт.");
      contact && contact.focus();
      return false;
    }

    if (!question || question.value.trim().length < 5) {
      showError(form, "Напишите вопрос, который хотите уточнить.");
      question && question.focus();
      return false;
    }

    if (question.value.trim().length > 2000) {
      showError(form, "Вопрос слишком длинный.");
      question.focus();
      return false;
    }

    showError(form, "");
    return true;
  }

  function getQuestionData(form) {
    fillHiddenFields(form);
    return getFormData(form);
  }

  function persistQuestionLocally(data) {
    const questions = JSON.parse(localStorage.getItem(`lavanda_questions_${siteId}`) || "[]");
    questions.push(data);
    localStorage.setItem(`lavanda_questions_${siteId}`, JSON.stringify(questions));

    track("question_submit", {
      form: "question",
    });
  }

  function hasAcceptedConsents(form) {
    const group = qs(".static-consents", form);
    if (!group) return true;
    return qsa('input[type="checkbox"]', group).every((checkbox) => checkbox.checked);
  }

  function isLocalDevelopment() {
    return (
      window.location.protocol === "file:" ||
      window.location.hostname === "localhost" ||
      window.location.hostname === "127.0.0.1" ||
      window.location.hostname === "[::1]"
    );
  }

  async function sendSubmission(formType, data) {
    try {
      const response = await fetch("/api/forms", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ formType, data }),
      });

      const payload = await response.json().catch(() => ({}));
      if (!response.ok) {
        const error = new Error(payload.error || "Не удалось отправить форму.");
        error.status = response.status;
        throw error;
      }

      return payload;
    } catch (error) {
      if (isLocalDevelopment() && (!error.status || error.status === 404)) {
        return { ok: true, localOnly: true };
      }
      throw error;
    }
  }

  function setThankYouCopy(kind) {
    const isQuestion = kind === "question";
    const content = qs(".thank-you__content");
    const title = qs("[data-thank-title]");
    const copy = qs("[data-thank-copy]");
    const help = qs("[data-thank-help]");
    const addService = qs("[data-add-service]");
    const titleText = isQuestion
      ? content?.dataset.questionTitle || "Вопрос отправлен"
      : content?.dataset.leadTitle || "Заявка принята";
    const copyText = isQuestion
      ? content?.dataset.questionCopy ||
        "Вопрос отправлен. Оператор ответит в Telegram или WhatsApp и подскажет дальнейшие шаги."
      : content?.dataset.leadCopy ||
        "Заявка принята. Мы напишем в Telegram или WhatsApp, уточним детали и пришлем расчет с комиссией. Переводить деньги нужно только после согласования суммы.";

    if (title) title.textContent = titleText;
    if (copy) copy.textContent = copyText;
    if (help) help.hidden = isQuestion;
    if (addService) addService.hidden = isQuestion;
  }

  function openThankYou(kind) {
    const dialog = qs("#thankYou");
    track("thank_you_view");
    setThankYouCopy(kind);

    if (dialog && typeof dialog.showModal === "function") {
      dialog.showModal();
      return;
    }

    window.alert(
      kind === "question"
        ? "Вопрос отправлен. Оператор ответит в Telegram или WhatsApp."
        : "Заявка принята. Мы напишем в Telegram или WhatsApp, уточним детали и пришлем расчет с комиссией. Переводить деньги нужно только после согласования суммы.",
    );
  }

  function initForms() {
    qsa(".lead-form").forEach((form) => {
      fillHiddenFields(form);

      form.addEventListener("input", () => {
        if (!selected.startedForms.has(form)) {
          selected.startedForms.add(form);
          track("form_start", { form: form.dataset.form });
        }
      });

      form.addEventListener("submit", async (event) => {
        event.preventDefault();
        const isQuestion = form.dataset.form === "question";

        if (isQuestion) {
          if (!validateQuestion(form)) return;
          if (!validateStaticConsents(form)) return;
        } else {
          if (!validateBase(form)) return;
          if (!validateStaticConsents(form)) return;
        }

        const submit = qs('button[type="submit"]', form);
        const label = submit ? submit.textContent : "";
        if (submit) {
          submit.disabled = true;
          submit.textContent = isQuestion ? "Отправляем вопрос..." : "Отправляем заявку...";
        }

        try {
          const data = isQuestion ? getQuestionData(form) : getLeadData(form);
          await sendSubmission(isQuestion ? "form2" : "form1", data);

          if (isQuestion) {
            persistQuestionLocally(data);
          } else {
            persistLeadLocally(data);
            reachApplicationSuccessGoal();
          }

          form.reset();
          showError(form, "");
          if (submit) {
            submit.disabled = Boolean(qs(".static-consents", form));
            submit.textContent = label;
          }
          openThankYou(isQuestion ? "question" : "lead");
        } catch (error) {
          showError(form, error.message || "Не удалось отправить форму. Попробуйте еще раз.");
          if (submit) {
            submit.disabled = !hasAcceptedConsents(form);
            submit.textContent = label;
          }
        }
      });
    });
  }

  function initConsentGates() {
    qsa(".static-consents").forEach((group) => {
      const scope = group.closest(".lead-form");
      if (!scope) return;

      const checkboxes = qsa('input[type="checkbox"]', group);
      const button = qs('button[type="submit"]', scope);
      if (!button || !checkboxes.length) return;

      const sync = () => {
        button.disabled = !checkboxes.every((checkbox) => checkbox.checked);
      };

      checkboxes.forEach((checkbox) => checkbox.addEventListener("change", sync));
      sync();
    });
  }

  function initFaq() {
    qsa(".faq-list details").forEach((item) => {
      item.addEventListener("toggle", () => {
        if (item.open) {
          track("faq_open", { question: qs("summary", item).textContent.trim() });
          qsa(".faq-list details").forEach((other) => {
            if (other !== item) other.open = false;
          });
        }
      });
    });
  }

  function initClicks() {
    qsa("[data-track]").forEach((el) => {
      el.addEventListener("click", () => track(el.dataset.track));
    });

    qsa("[data-prefill]").forEach((el) => {
      el.addEventListener("click", () => setService(el.dataset.prefill, { scroll: false }));
    });

    qsa(".chip[data-service]").forEach((chip) => {
      chip.addEventListener("click", () => {
        const isInsideForm = Boolean(chip.closest(".lead-form"));
        setService(chip.dataset.service, { scroll: !isInsideForm });
      });
    });

    qsa('[href*="t.me"], [href*="wa.me"]').forEach((link) => {
      link.addEventListener("click", () => track("messenger_click", { href: link.href }));
    });

    qsa("[data-close-dialog]").forEach((button) => {
      button.addEventListener("click", () => qs("#thankYou").close());
    });

    qsa("[data-add-service]").forEach((button) => {
      button.addEventListener("click", () => {
        const dialog = qs("#thankYou");
        if (dialog && dialog.open) dialog.close();
        track("add_second_service_click");
        qs("#request").scrollIntoView({ behavior: "smooth", block: "start" });
        const form = qs(".lead-form--mini");
        if (form) {
          const service = qs('input[name="service"]', form);
          if (service) {
            service.value = "";
            service.focus();
          }
        }
      });
    });
  }

  function initCookieBanner() {
    const cookieName = `lavanda_cookie_notice_accepted_${siteId}`;
    const banner = qs("[data-cookie-banner]");
    const button = qs("[data-cookie-accept]");
    if (!banner || !button) return;

    if (getCookie(cookieName) === "yes") {
      banner.classList.add("is-hidden");
      return;
    }

    try {
      if (localStorage.getItem(cookieName) === "yes") {
        setCookie(cookieName, "yes", {
          maxAge: 60 * 60 * 24 * 180,
          path: "/",
          sameSite: "Lax",
          secure: window.location.protocol === "https:",
        });
        localStorage.removeItem(cookieName);
        banner.classList.add("is-hidden");
        return;
      }
    } catch (error) {
      // Ignore legacy migration errors and keep the notice visible.
    }

    button.addEventListener("click", () => {
      banner.classList.add("is-hidden");
      try {
        setCookie(cookieName, "yes", {
          maxAge: 60 * 60 * 24 * 180,
          path: "/",
          sameSite: "Lax",
          secure: window.location.protocol === "https:",
        });
        localStorage.removeItem(cookieName);
      } catch (error) {
        // The banner is still hidden for the current page view.
      }
      track("cookie_notice_accept");
    });
  }

  document.addEventListener("DOMContentLoaded", () => {
    track("page_view", {
      site_id: siteId,
      path: window.location.pathname,
      search: window.location.search,
      device_type: window.matchMedia("(max-width: 760px)").matches ? "mobile" : "desktop",
    });
    initForms();
    initConsentGates();
    initFaq();
    initClicks();
    initCookieBanner();
  });
})();
